import context, { ApiResultModel, ITaskCreator } from '@truckdown/systems';
import { defineComponent, ref, Ref, onMounted, onUnmounted } from 'vue';
import { Constants } from '../../constants';

interface IData {
    count: Ref<number>;
    unassigned: Ref<number>;
}

const getData = function () {
    return {
        count: ref<number>(0),
        unassigned: ref<number>(0)
    } as IData;
}

const isCsrOrAdmin = function () {
    if (!context.isAuthenticated) {
        return false;
    }
    return context.isInRole(Constants.Roles.SystemRole)
        || context.isInRole(Constants.Roles.CSRRole);
}

const getTasksCount = async function () {
    try {
        let service = await context.getService<ITaskCreator>('ITaskCreator');
        return await service.getCounts();
    }
    catch (err) {
        console.log(err);
        return {
            ok: false,
            message: 'Error getting task counts'
        }
    }
}

const assignTaskCounts = async function (data: IData) {
    var counts = await getTasksCount();
    if (counts.ok) {
        data.count.value = counts.data ?? 0;
        data.unassigned.value = counts.data2 ?? 0;
    }
}

export default defineComponent({
    name: 'AdminTasksLink',
    setup: function (props, ctx) {
        let data = getData();

        if (isCsrOrAdmin()) {
            const handleUpdateTask = async function () {
                await assignTaskCounts(data);
            }

            onMounted(async () => {
                await assignTaskCounts(data);
                context.events.on('new-task', handleUpdateTask);
                context.events.on('update-task', handleUpdateTask);
                context.events.on('update-task-counts', handleUpdateTask);
            });
            onUnmounted(() => {
                context.events.off('new-task', handleUpdateTask);
                context.events.off('update-task', handleUpdateTask);
                context.events.off('update-task-counts', handleUpdateTask);
            });
        }

        return {
            ...data
        };
    }
});


